import { render, staticRenderFns } from "./session-management-notification.vue?vue&type=template&id=ac88c5e2&"
import script from "./session-management-notification.vue?vue&type=script&lang=ts&"
export * from "./session-management-notification.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Dialog: require('/home/vsts/work/1/s/frontend/components/dialog.vue').default})
